import { COLUMN_NODE_SIZE, COLUMN_SHADOW_WIDTH, COLUMN_TEXT_LIMIT, COLUMN_TEXT_OFFSET, COLUMN_TEXT_SIZE, DOMAIN_NODE_SIZE, DOMAIN_SHADOW_WIDTH, DOMAIN_TEXT_LIMIT, DOMAIN_TEXT_OFFSET, DOMAIN_TEXT_SIZE, TABLE_NODE_SIZE, TABLE_SHADOW_WIDTH, TABLE_TEXT_LIMIT, TABLE_TEXT_OFFSET, TABLE_TEXT_SIZE } from "../config";
import { TCanvasNode } from "../types/TCanvasNode";

export default function getNodeSize(node: TCanvasNode): number {
  if(node.node_type == 'DOMAIN') {
    return DOMAIN_NODE_SIZE
  } else if(node.node_type == 'TABLE') {
    return TABLE_NODE_SIZE
  } else if(node.node_type == "COLUMN") {
    return COLUMN_NODE_SIZE
  } else {
    // alert(node.node_type)
    return COLUMN_NODE_SIZE - 2
  }
}

export function getTextOffset(node: TCanvasNode): number {
  if(node.node_type == 'DOMAIN') {
    return DOMAIN_TEXT_OFFSET
  } else if(node.node_type == 'TABLE') {
    return TABLE_TEXT_OFFSET
  } else if(node.node_type == "COLUMN") {
    return COLUMN_TEXT_OFFSET
  } else {
    return COLUMN_TEXT_OFFSET
  }
}

export function getTextSize(node: TCanvasNode): number {
  if(node.node_type == 'DOMAIN') {
    return DOMAIN_TEXT_SIZE
  } else if(node.node_type == 'TABLE') {
    return TABLE_TEXT_SIZE
  } else if(node.node_type == "COLUMN") {
    return COLUMN_TEXT_SIZE
  } else {
    return COLUMN_TEXT_SIZE
  }
}

export function getTextLimit(node: TCanvasNode): number {
  if(node.node_type == 'DOMAIN') {
    return DOMAIN_TEXT_LIMIT
  } else if(node.node_type == 'TABLE') {
    return TABLE_TEXT_LIMIT
  } else if(node.node_type == "COLUMN") {
    return COLUMN_TEXT_LIMIT
  } else {
    return COLUMN_TEXT_LIMIT
  }
}

const binarySearch = ({ max, getValue, match }: {
  max: number;
  getValue: (guess: number) => number;
  match: number;
}): number => {
  let min = 0;

  while (min <= max) {
    const guess = Math.floor((min + max) / 2);
    const compareVal = getValue(guess);

    if (compareVal === match) return guess;
    if (compareVal < match) min = guess + 1;
    else max = guess - 1;
  }

  return max;
};

export const fitString = (
  ctx: CanvasRenderingContext2D,
  str: string,
  maxWidth: number,
): string => {
  const width = ctx.measureText(str).width;
  const ellipsis = '…';
  const ellipsisWidth = ctx.measureText(ellipsis).width;
  if (width <= maxWidth || width <= ellipsisWidth) {
    return str;
  }

  const index = binarySearch({
    max: str.length,
    getValue: (guess: number) => ctx.measureText(str.substring(0, guess)).width,
    match: maxWidth - ellipsisWidth,
  });

  return str.substring(0, index) + ellipsis;
};


export function getShadowSize(node: TCanvasNode) {
  if(node.node_type == 'DOMAIN') {
    return DOMAIN_SHADOW_WIDTH
  } else if(node.node_type == 'TABLE') {
    return TABLE_SHADOW_WIDTH
  } else if(node.node_type == "COLUMN") {
    return COLUMN_SHADOW_WIDTH
  } else {
    return COLUMN_SHADOW_WIDTH
  }
}
